import { render, staticRenderFns } from "./SelectPartners.vue?vue&type=template&id=15f51ee4"
import script from "./SelectPartners.vue?vue&type=script&lang=js"
export * from "./SelectPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports